{
	"ariaTooltip": "tooltip",
	"gotIt": "Got it",
	"next": "Next",
	"previous": "Previous"
}
